import { DateTime } from 'luxon';

declare module 'luxon/src/datetime' {
  export interface DateTime {
    nextMonday(): DateTime;
  }
}

DateTime.prototype.nextMonday = function nextMonday() {
  let dt = this as DateTime;

  while (dt.weekday !== 1) {
    dt = dt.plus({ day: 1 });
  }

  return dt;
};

export default DateTime;
